import React, { useState } from "react";
import { TwitterPicker } from "react-color";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import "./HabitControlPanel.scss";
import { useDispatch, useSelector } from "react-redux";
import constants from "common/constants";
import Icon from "components/Icon/Icon";
import { shouldFontColorBeLight } from "utils/colors";
import TimePicker from "rc-time-picker";

export default function HabitControlPanel({
  onEditClick,
  onColorChange,
  habit,
  attributes,
  listeners,
  setActivatorNodeRef,
  onTimeChange,
}) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const isControlPanelVisible = useSelector(
    (state) => state.controlPanel.isVisible
  );

  const [showTimePicker, setShowTimePicker] = useState(false);
  const [timeValue, setTimeValue] = useState(
    habit.time ? moment(habit.time, "HH:mm").format("HH:mm") : "--"
  );

  const scales = constants.scales;
  const color = habit.color;
  const iconSize = 22;

  const getIconColor = (bgColor) => {
    return shouldFontColorBeLight(bgColor)
      ? scales[color][0]
      : scales[color][scales[color].length - 2];
  };

  const getDatetimeValue = () => {
    const momentTime = moment(timeValue, "HH:mm");
    return timeValue !== "--" && momentTime.isValid() ? momentTime : null;
  };

  const handleTimeChange = (momentObj) => {
    const newTime =
      momentObj && momentObj.isValid() ? momentObj.format("HH:mm") : "--";

    // Check if minutes are different than current
    const currentMinutes =
      timeValue !== "--" ? moment(timeValue, "HH:mm").minutes() : null;
    const newMinutes =
      momentObj && momentObj.isValid() ? momentObj.minutes() : null;

    if (
      currentMinutes !== null &&
      newMinutes !== null &&
      currentMinutes !== newMinutes
    ) {
      setTimeValue(newTime);
      setShowTimePicker(false);
      onTimeChange(newTime);
    } else {
      setTimeValue(newTime);
      onTimeChange();
    }
  };

  const handleTimePickerClose = () => {
    setShowTimePicker(false);
    // onTimeChange(timeValue);
  };

  const handleTimeClick = (e) => {
    e.stopPropagation();
    setShowTimePicker(!showTimePicker);
  };

  function handleColorClick() {
    console.log("handleColorClick");
    setDisplayColorPicker(!displayColorPicker);
  }

  function handleClose() {
    setShowTimePicker(false);
  }

  function handleChange(color) {
    onColorChange(color);
    setDisplayColorPicker(false);
  }

  const colors = [
    "#249c03",
    "#249cFF",
    "#ffa503",
    "#ff0000",
    "#a64ca6",
    "#888888",
    "#329999",
  ];

  if (!isControlPanelVisible) return null;

  return (
    <div className="habit-control-panel">
      <div
        className="control-block edit-block"
        onClick={onEditClick}
        style={{
          backgroundColor: scales[color][4],
        }}
      >
        <Icon
          className="controlpanel-icon"
          name="Edit"
          color={getIconColor(scales[color][4])}
          size={iconSize}
        />
      </div>
      <div
        className="control-block color-block no-drag"
        onClick={handleColorClick}
        style={{
          backgroundColor: scales[color][3],
        }}
      >
        <Icon
          className="controlpanel-icon"
          name="Circle"
          color={getIconColor(scales[color][3])}
          size={iconSize}
        />
        {displayColorPicker && (
          <div className="popover">
            <div className="cover" onClick={handleClose} />
            <div className="picker-wrapper">
              <TwitterPicker
                className="twitter-picker"
                colors={colors}
                onChange={handleChange}
              />
            </div>
          </div>
        )}
      </div>
      <div
        {...attributes}
        {...listeners}
        ref={setActivatorNodeRef}
        className="control-block"
        onClick={handleColorClick}
        style={{
          backgroundColor: scales[color][2],
        }}
      >
        <Icon
          className="controlpanel-icon"
          name="Hamburger"
          color={getIconColor(scales[color][2])}
          size={iconSize}
        />
      </div>
      {/* <div
        className="control-block"
        style={{
          backgroundColor: scales[color][1],
        }}
      >
        <Icon
          className="controlpanel-icon"
          name="Bell"
            color={getIconColor(scales[color][1])}
        />
      </div> */}
      <div
        className="control-block"
        style={{
          backgroundColor: scales[color][1],
        }}
      >
        {!showTimePicker && (
          <a
            className="time"
            onClick={handleTimeClick}
            style={{
              color: getIconColor(scales[color][1]),
              cursor: "pointer",
            }}
          >
            {timeValue}
          </a>
        )}
        {showTimePicker && (
          <TimePicker
            className="time-picker-bg"
            popupClassName="time-picker-bg"
            defaultValue={getDatetimeValue()}
            open={showTimePicker}
            inputIcon={undefined}
            clearIcon={undefined}
            allowEmpty={false}
            onOpen={() => setShowTimePicker(true)}
            onClose={handleTimePickerClose}
            onChange={handleTimeChange}
            showSecond={false}
            focusOnOpen
          />
        )}
      </div>
    </div>
  );
}
